import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: ReactNode;
}

export default function SectionHeading({ eyebrow, title, description, action }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-col gap-3 border-b border-background-200 pb-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        {eyebrow ? (
          <p className="mb-1.5 flex items-center gap-2 font-label text-[11px] uppercase tracking-[0.2em] text-primary-600">
            <span className="inline-block h-[2px] w-6 bg-primary-500" />
            {eyebrow}
          </p>
        ) : null}
        <h2 className="font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">{title}</h2>
        {description ? <p className="mt-1.5 text-sm text-foreground-500">{description}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}